import ApiService from './api.service';

export default class ResourceTagService {
  static async fetchResourceTags(lang) {
    const tags = await ApiService.get('/resources/tags/' + lang);
    return tags;
  }
  static async updateResourceTags(lang, type, tags) {
    const newTags = await ApiService.put(`/resources/tags/${lang}/${type}`, { tags });
    return newTags;
  }
}
